'use client'

import { useParams } from 'next/navigation'
import { ViewTransition } from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { productImageTransitionName } from '@/features/products-catalog/view-transition'

/**
 * Placeholder da imagem do hero enquanto a página de info carrega. Recebe o
 * mesmo nome da imagem do card em /cursos: no clique, o card morfa para este
 * bloco e, quando o produto chega, o bloco morfa para a imagem real do hero.
 */
export function ProductImageSkeleton() {
  const { id } = useParams<{ id: string }>()

  return (
    <ViewTransition
      default="none"
      name={id ? productImageTransitionName(id) : undefined}
      share="morph"
    >
      <Skeleton className="mx-auto h-80.5 w-[20rem] rounded-lg bg-gray-200 lg:w-114" />
    </ViewTransition>
  )
}
